import React, { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { CardContext } from './context/CardContext';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { Navbar, Nav, Container } from 'react-bootstrap';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';


const Navbars = () => {
    const { qty } = useContext(CardContext);


    return <>
        {/* <div className='container-fluid'>
            <div className="row main_div">
                <div className='col-12 max-auto mt-3'> */}
        <Navbar bg="light" variant="light" sticky="top" className="">
            <Container>
                <Navbar.Brand href="#home"> <span style={{ color: "#28B463", fontWeight: "bold" }} className="shoppingWebsite">  Ice Cream </span> </Navbar.Brand>
                <Nav className="right">
                    <NavLink exact activeClassName="menu_active " className="nav-link menu-btn" to="/">
                        Home
                    </NavLink>
                    <NavLink exact activeClassName="menu_active" className="nav-link" to="/order">
                        <div className="mx-4">
                            <ShoppingCartIcon style={{ color: "#28B463" }} /> <span style={{ fontSize: "15px", fontWeight: "bold" }} >{qty} </span>
                        </div>
                    </NavLink>
                </Nav>
            </Container>
        </Navbar>
        {/* </div>
            </div>
        </div> */}

        {/* <Navbar bg="light" variant="light" sticky="top" className="right">
            <Container>
                <Navbar.Brand href="#home"> <span style={{ color: "#28B463", fontWeight: "bold" }} > Shopping WebSite</span> </Navbar.Brand>
                <Nav className="right">
                    <NavLink exact activeClassName="menu_active " className="nav-link menu-btn" to="/">
                        <HomeRoundedIcon />   Home
                    </NavLink>
                    <NavLink exact activeClassName="menu_active" className="nav-link" to="/order">
                        <div className="mx-4">
                            <ShoppingCartIcon style={{ color: "#28B463" }} /> <span style={{ fontSize: "15px", fontWeight: "bold" }} >{qty} </span>
                        </div>
                    </NavLink>
                </Nav>
            </Container>
        </Navbar> */}
    </>;
};
export default Navbars;
